<mat-dialog-content>
  <h2 mat-dialog-title>Add an address</h2>
  <button style="position: absolute; right: 12px; top: 12px" mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <wz-enter-address (save)="dialogRef.close($event)" [isDialog]="true"></wz-enter-address>
</mat-dialog-content>
